import { useState } from "react";

import { Button, Callout, FormGroup, InputGroup } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import {
  AvailableCreditsDocument,
  RedeemGiftCodeMutation,
  useRedeemGiftCodeMutation,
} from "@/graphql";
import { formatErrors } from "@/utils/array";

export function RedeemGiftCode({
  onCompleted,
}: {
  onCompleted: (response: RedeemGiftCodeMutation) => void;
}) {
  const [code, setCode] = useState("");

  const [redeem, { data, loading }] = useRedeemGiftCodeMutation({
    variables: { code },
    refetchQueries: [{ query: AvailableCreditsDocument }],
    onCompleted: (response) => {
      if (response?.redeemGiftCode?.ok) {
        setCode("");
      }
      onCompleted(response);
    },
  });

  const errors = formatErrors(data?.redeemGiftCode?.errors);

  return (
    <>
      <FormGroup label={<b>Enter Gift Code</b>}>
        <InputGroup
          large={true}
          autoFocus={true}
          value={code}
          placeholder="Gift code"
          onChange={(e) => setCode(e.target.value)}
          disabled={loading}
          style={{ height: 60 }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              redeem();
            }
          }}
        />
      </FormGroup>
      <FormGroup>
        <Button
          large={true}
          intent="primary"
          disabled={!code.length || loading}
          loading={loading}
          onClick={redeem}
        >
          Redeem
        </Button>
      </FormGroup>
      {!!errors && (
        <Box mt={3}>
          <Callout intent="warning" title="Oh no!">
            That code didn't work. {errors}
          </Callout>
        </Box>
      )}
    </>
  );
}
